import { Card, Divider, Link, Typography } from '@mui/joy';

const Branding = () => {
	return (
		<div className='flex flex-col items-center justify-center'>
			<div className='text-6xl md:text-9xl text-[#002984]'>
				<span style={{
					color: "white",
					textShadow: "-1px -1px 0 #002984,  1px -1px 0 #002984,-1px 1px 0 #002984,1px 1px 0 #002984"
				}}>Web</span><span>Mark</span>
			</div>
			<div className='my-6'>
				<span className='text-center text-xl md:text-3xl'>
					A Smarter way to manage bookmarks.
				</span>
			</div>
			<div className='grid grid-rows-4 grid-flow-row gap-4 my-6 text-center mx-6 md:mx-0'>
				<Card className="flex items-center justify-center" variant='outlined'>
					<Typography className='text-[#002984]' level='h4'>Add Bookmarks</Typography>
				</Card>
				<Card className="flex items-center justify-center" variant='outlined'>
					<Typography className='text-[#002984]' level='h4'>Create Category</Typography>
				</Card>
				<Card className="flex items-center justify-center" variant='outlined'>
					<Typography className='text-[#002984]' level='h4'>Works on any chromium browser</Typography>
				</Card>
				<Card className="flex items-center justify-center" variant='outlined'>
					<Typography className='text-[#002984]' level='h4'>Create sharable links for category</Typography>
				</Card>
			</div>
			<div className='my-6'>
				<Link sx={{ color: "white", backgroundColor: "#002984", padding: "10px 20px", textDecoration: "none" }} target="_blank" href="https://chrome.google.com/webstore/detail/webmark/glndcakmiiajcodokfkhehnholffmhbn/">Add Extension</Link>
			</div>
			<Divider />
			<div className='my-6 text-center'>
				<div className='flex items-center justify-center'>
					<img style={{ width: "20px", display: "inline", margin: "0 10px" }} src='/india.png' alt='IN' /> <span>भारत में निर्मित</span>
				</div>
			</div>
		</div>
	)
}

export default Branding;